(() => {
  if (window.spiritElementAudioLoaded) return;
  window.spiritElementAudioLoaded = true;

  const updateButton = (button, isPlaying) => {
    const label = isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel;

    button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    if (label) button.setAttribute('aria-label', label);
  };

  const pauseOtherPlayers = (currentAudio) => {
    document.querySelectorAll('[data-spirit-frequency-audio]').forEach((audio) => {
      if (audio !== currentAudio && !audio.paused) audio.pause();
    });
  };

  const initializePlayers = (root = document) => {
    root.querySelectorAll('[data-spirit-frequency-player]').forEach((player) => {
      if (player.dataset.spiritFrequencyReady === 'true') return;

      const button = player.querySelector('[data-spirit-frequency-toggle]');
      const audio = player.querySelector('[data-spirit-frequency-audio]');
      const status = player.querySelector('[data-spirit-frequency-status]');
      if (!button || !audio) return;

      button.addEventListener('click', async () => {
        if (!audio.paused && !audio.ended) {
          audio.pause();
          return;
        }

        pauseOtherPlayers(audio);
        if (audio.ended) audio.currentTime = 0;

        try {
          await audio.play();
          if (status) status.textContent = '';
        } catch (error) {
          updateButton(button, false);
          if (status) status.textContent = status.dataset.errorLabel || '';
        }
      });

      audio.addEventListener('play', () => updateButton(button, true));
      audio.addEventListener('pause', () => updateButton(button, false));
      audio.addEventListener('ended', () => updateButton(button, false));
      audio.addEventListener('error', () => {
        updateButton(button, false);
        if (status) status.textContent = status.dataset.errorLabel || '';
      });

      updateButton(button, false);
      player.dataset.spiritFrequencyReady = 'true';
    });
  };

  initializePlayers();
  document.addEventListener('shopify:section:load', (event) => initializePlayers(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-spirit-frequency-audio]').forEach((audio) => audio.pause());
  });
})();
